export default function parseBold(xmlNode) {
  return {
    type: "text",
    text: xmlNode.textContent,
    marks: [{ type: "strong" }],
  };
}
